import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../imageWithBasePath";
import { all_routes } from "../../../feature-module/router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import {
  setExpandMenu,
  setMiniSidebar,
  setMobileSidebar,
} from "../../data/redux/commonSlice";
const Header = () => {
  const route = all_routes;
  const location = useLocation();
  const dispatch = useDispatch();
  const mobileSidebar = useSelector((state: any) => state.mobileSidebar);
  const miniSidebar = useSelector((state: any) => state.miniSidebar);

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };
  const toggleMiniSidebar = () => {
    dispatch(setMiniSidebar(!miniSidebar));
  };
  const toggleExpandMenu = () => {
    dispatch(setExpandMenu(true));
  };
  const toggleExpandMenu2 = () => {
    dispatch(setExpandMenu(false));
  };

  const [layoutBs, setLayoutBs] = useState(
    () => localStorage.getItem("dataTheme") || "light"
  );
  const isLockScreen = location.pathname === "/lock-screen";

  const applyTheme = (theme: string) => {
    localStorage.setItem("dataTheme", theme);
    document.documentElement.setAttribute("data-theme", theme);
    document.body.setAttribute("data-theme", theme);
    document.documentElement.setAttribute("data-bs-theme", theme);
    setLayoutBs(theme);
    window.dispatchEvent(new CustomEvent("theme-change", { detail: theme }));
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem("dataTheme") || "light";
    document.documentElement.setAttribute("data-theme", savedTheme);
    document.body.setAttribute("data-theme", savedTheme);
    document.documentElement.setAttribute("data-bs-theme", savedTheme);
    setLayoutBs(savedTheme);

    const handleThemeChange = (e: any) => {
      const newTheme = e.detail || localStorage.getItem("dataTheme") || "light";
      setLayoutBs(newTheme);
    };
    window.addEventListener("theme-change", handleThemeChange);
    return () => window.removeEventListener("theme-change", handleThemeChange);
  }, []);

  if (isLockScreen) {
    return null;
  }

  const LayoutDark = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    applyTheme("dark");
  };

  const LayoutLight = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    applyTheme("light");
  };

  const toggleTheme = () => {
    applyTheme(layoutBs === "dark" ? "light" : "dark");
  };

  const currentUsername =
    localStorage.getItem("username") ||
    sessionStorage.getItem("username") ||
    "User";

  const currentGroup =
    localStorage.getItem("group") ||
    sessionStorage.getItem("group") ||
    "Staff";

  return (
    <>
      <header className="header fixed-top d-flex align-items-center justify-content-between">
        {/* Left Section: Logo & Toggle Button */}
        <div
          className={`header-left d-flex align-items-center ${
            miniSidebar ? "mini-header-left justify-content-center" : "justify-content-between"
          }`}
          onMouseEnter={toggleExpandMenu}
          onMouseLeave={toggleExpandMenu2}
        >
          {/* Normal Logo for expanded sidebar */}
          <Link
            to={route.Dashboard}
            className={`logo logo-normal align-items-center ${miniSidebar ? "d-none" : "d-flex"}`}
          >
            <ImageWithBasePath
              src="/assets/img/nav_bar_logo-removebg-preview.png"
              alt="KIU Logo"
              style={{ maxHeight: "38px", width: "auto" }}
            />
          </Link>

          {/* Small Logo for collapsed sidebar */}
          <Link
            to={route.Dashboard}
            className={`logo-small align-items-center ${miniSidebar ? "d-flex" : "d-none"}`}
          >
            <ImageWithBasePath
              src="/assets/img/logo-small.svg"
              alt="KIU Logo Small"
              style={{ maxHeight: "32px", width: "auto" }}
            />
          </Link>

          {/* Sidebar Toggle Button */}
          <Link
            id="toggle_btn"
            to="#"
            onClick={(e) => {
              e.preventDefault();
              toggleMiniSidebar();
            }}
            title={miniSidebar ? "Expand Sidebar" : "Collapse Sidebar"}
            className="d-flex align-items-center justify-content-center"
          >
            <i className={`ti ${miniSidebar ? "ti-arrow-bar-to-right" : "ti-arrow-bar-to-left"}`} />
          </Link>
        </div>

        {/* Mobile Sidebar Hamburger Button */}
        <Link
          id="mobile_btn"
          className="mobile_btn d-lg-none ms-2"
          to="#sidebar"
          onClick={toggleMobileSidebar}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>

        {/* Center: Global Quick Search */}
        <div className="header-search-wrap d-none d-md-flex align-items-center">
          <i className="ti ti-search search-icon" />
          <input
            type="text"
            placeholder="Search resource, room, booking..."
            className="form-control"
          />
          <span className="search-shortcut">⌘K</span>
        </div>

        {/* Right Section: Theme Toggle & Executive Profile */}
        <div className="header-right-controls d-flex align-items-center">
          {/* Day / Night Theme Pill Switcher */}
          <div
            className={`dark-mode-toggle ${layoutBs === "dark" ? "is-dark" : "is-light"}`}
            onClick={toggleTheme}
            title={layoutBs === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
            role="button"
            tabIndex={0}
          >
            <div className="toggle-thumb" />
            <i
              className={`ti ti-sun light-mode ${layoutBs === "dark" ? "" : "active"}`}
              onClick={LayoutLight}
              title="Light Mode"
            />
            <i
              className={`ti ti-moon dark-mode ${layoutBs === "dark" ? "active" : ""}`}
              onClick={LayoutDark}
              title="Dark Mode"
            />
          </div>

          {/* Executive User Profile Chip & Dropdown */}
          <div className="dropdown">
            <Link
              to="#"
              className="header-user-chip"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <div className="user-info-text d-flex">
                <span className="user-name">{currentUsername}</span>
                <span className="user-role-badge">{currentGroup}</span>
              </div>
              <i className="ti ti-chevron-down chevron-icon" />
            </Link>

            {/* Dropdown Menu */}
            <div className="dropdown-menu dropdown-menu-end shadow-lg">
              <div className="p-3 border-bottom mb-2 bg-light rounded-3">
                <div className="fw-bold text-dark" style={{ fontSize: "0.9rem" }}>
                  {currentUsername}
                </div>
                <div className="text-muted mt-1" style={{ fontSize: "0.78rem" }}>
                  Role: <span className="text-primary fw-semibold">{currentGroup}</span>
                </div>
              </div>
              <div>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2 rounded-2 text-danger"
                  to={route.login}
                  onClick={() => {
                    localStorage.removeItem("token");
                    sessionStorage.removeItem("token");
                  }}
                >
                  <i className="ti ti-logout fs-5" /> <strong>Sign Out</strong>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
